import React, { ComponentType, FC } from 'react';
import EmptyTableMessage from 'components/EmptyTableMessage';
import { TableTerms } from 'components/EmptyTableMessage/types';
import useCheckFeatures from './hooks';
import { FeatureEnablerProps } from './types';
/*
  localStorage should be something like
  {
    ...otherThings,
    features: {
      documents: true,
      exports: false,
      newerFeature: true
    }
  }
*/
const FeatureEnabler: FC<FeatureEnablerProps> = ({ children, enabler, hideComponent, alternativeComponent }) => {
  const [, checkFeature] = useCheckFeatures();
  const isCurrentFeatureEnabled = checkFeature(enabler);

  if (hideComponent && !isCurrentFeatureEnabled) {
    return null;
  }

  if (alternativeComponent) {
    const AlternativeComponent = alternativeComponent as ComponentType;
    if (!isCurrentFeatureEnabled) {
      return <AlternativeComponent />;
    }
  }

  if (isCurrentFeatureEnabled) {
    return children;
  }

  return (
    <EmptyTableMessage
      title="This feature is coming soon!"
      tableTerms={{} as TableTerms}
      tagline="Contact us if you would like early access."
    />
  );
};

export default FeatureEnabler;
